import { render, staticRenderFns } from "./CustomNav.vue?vue&type=template&id=f2379476&scoped=true"
import script from "./CustomNav.vue?vue&type=script&lang=js"
export * from "./CustomNav.vue?vue&type=script&lang=js"
import style0 from "./CustomNav.vue?vue&type=style&index=0&id=f2379476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2379476",
  null
  
)

export default component.exports